"use client";
import React, { useEffect } from "react";
import "./ConstructionUpdate.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import Image from "next/image";

function ConstructionUpdate({ projectDetail }) {
  const progress =
    Number(projectDetail?.construction?.progress_percent) || 0;

  // ✅ Dynamic images from API
  const constructionImages =
    projectDetail?.construction_data?.image || [];

  useEffect(() => {
    Fancybox.bind("[data-fancybox='construction']", {
      Thumbs: false,
      Toolbar: {
        display: ["close"],
      },
    });

    return () => {
      Fancybox.unbind("[data-fancybox='construction']");
    };
  }, []);

  // ❌ Hide section if no data
  if (!constructionImages.length) return null;

  return (
    <section className="section-padding light-bg-section construction-section">
      <div className="main-container">

        {/* TOP */}
        <div className="construction-header">
          <div className="fourth-title-text">
            <h3>
              {projectDetail?.construction?.title || "Construction Update"}
            </h3>
          </div>

          <div className="progress-wrapper">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="progress-labels">
              <span>{progress}%</span>
              <span>100%</span>
            </div>
          </div>
        </div>

        {/* GRID */}
        <div className="construction-grid">
          {constructionImages.map((item, index) => {
            const thumb = `${item.image}&w=540&h=360`; // ✅ thumbnail
            const full = item.image_main; // ✅ original image

            return (
              <a
                key={index}
                href={full}
                data-fancybox="construction"
                className="construction-item"
              >
                <div
                  className="construction-img-wrapper"
                  style={{ aspectRatio: "3 / 2", position: "relative" }}
                >
                  <Image
                    src={thumb}
                    alt={`construction-${index}`}
                    fill
                    sizes="(max-width: 768px) 100vw, 33vw"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </a>
            );
          })}
        </div>

        {/* Hidden preload for smooth navigation */}
        <div style={{ display: "none" }}>
          {constructionImages.map((item, i) => (
            <a
              key={i}
              href={item.image_main}
              data-fancybox="construction"
            ></a>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ConstructionUpdate;